// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IUxX","rootMobile":"styles_rootMobile__1R1WA"};